import { Injectable } from '@angular/core';
import { environment } from './environments/environment';
import { OnboardingData } from './models/onboarding-data.model';

@Injectable({ providedIn: 'root' })
export class ServiceManagerService {

  notifyApplicationSubmitted(applicationId: string, data: OnboardingData): void {
    const { contactDetails, fleetOps, confirmations } = data;
    const dispatchValue = fleetOps.dispatchSystem === 'Other'
      ? fleetOps.dispatchSystemOther
      : fleetOps.dispatchSystem;

    const payload = {
      application_id: applicationId,
      legal_entity_name: contactDetails.legalEntityName || null,
      fleet_name: contactDetails.fleetName || null,
      fleet_phone: contactDetails.fleetPhone || null,
      address_line1: contactDetails.address.line1 || null,
      address_line2: contactDetails.address.line2 || null,
      address_city: contactDetails.address.city || null,
      address_county: contactDetails.address.county || null,
      address_postcode: contactDetails.address.postcode || null,
      latitude: contactDetails.address.latitude,
      longitude: contactDetails.address.longitude,
      contact_name: contactDetails.contactName || null,
      contact_email: contactDetails.contactEmail || null,
      contact_phone: contactDetails.contactPhone || null,
      use_legal_name_as_fleet_name: contactDetails.useLegalNameAsFleetName,
      fleet_size_band: fleetOps.fleetSize || null,
      service_level: fleetOps.serviceLevel || null,
      dispatch_system: dispatchValue || null,
      prebook_pct: fleetOps.workSplit.bookingType.prebook,
      asap_pct: fleetOps.workSplit.bookingType.asap,
      account_pct: fleetOps.workSplit.paymentType.account,
      card_pct: fleetOps.workSplit.paymentType.card,
      cash_pct: fleetOps.workSplit.paymentType.cash,
      terms_accepted: confirmations.terms,
      terms_accepted_at: confirmations.termsAcceptedAt,
      data_sharing_accepted: confirmations.dataSharing,
      data_sharing_accepted_at: confirmations.dataSharingAcceptedAt,
      code_of_conduct_accepted: confirmations.codeOfConduct,
      code_of_conduct_accepted_at: confirmations.codeOfConductAcceptedAt,
      authorised_signatory_confirmed: confirmations.isAuthorised,
    };

    fetch(environment.serviceManagerUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-key': environment.serviceManagerApiKey,
      },
      body: JSON.stringify(payload),
    })
      .then(response => {
        if (!response.ok) {
          console.error(`Service manager notification failed: ${response.status} ${response.statusText}`);
        }
      })
      .catch(error => {
        console.error('Failed to notify service manager:', error);
      });
  }
}
